export default __webpack_public_path__ + "static/media/cidade.3bde2a38.jpeg";